import { Record } from 'immutable'

const State = Record({}, 'OrganizationResourcesUsage')

const OrganizationResourcesUsageReducer = (state = new State()) => {
  return state
}

export default OrganizationResourcesUsageReducer
